import React, { useContext } from "react";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import Question from "../../../Question";
import LearnMore from "../../../LearnMore";
import { getTrueClasses } from "../../../../../../helpers";
import "./index.scss";

const ComplexTitle = ({ title, pack }) => {
  const {
    translate: { countryCode, t },
  } = useContext(SimpleContext);
  return (
    <div
      className={getTrueClasses(
        "GP-C-O-O-CT",
        countryCode === "US" && "GP-C-O-O-CT_us"
      )}
    >
      <p className="GP-C-O-O-CT__title">{t(title)}</p>
      <ul className="GP-C-O-O-CT-pack">
        {pack.map(({ text, tooltip, textUS, tooltipUS, learnMorePath }, i) => (
          <li
            key={i}
            className={`GP-C-O-O-CT__text GP-C-O-O-CT__text_t${i + 1}`}
          >
            {parse(t(countryCode === "US" && textUS ? textUS : text))}
            {tooltip && (
              <Question
                tooltip={t(
                  countryCode === "US" && tooltipUS ? tooltipUS : tooltip
                )}
              />
            )}
            {learnMorePath && <LearnMore path={learnMorePath} />}
          </li>
        ))}
      </ul>
    </div>
  );
};
ComplexTitle.propTypes = {
  title: PropTypes.string,
  pack: PropTypes.array,
};
export default ComplexTitle;
